import Modal from '@roo/roo/Modal';
import { warningToast } from '@utils/toast';
import { printOrderWhenConfirm } from '@utils/print/orderPrintService';
import { getStorage, setStorage } from '@utils/localStorage';
import { CUSTOM_METRICS, reportCustomMetrics } from '@utils/owlReporter';
import openSignProtocolModal from '@utils/phf/openSignProtocolModal';
import { isUniversalWindowsXP, runtimeType } from '@utils/getEnv';
import * as Ids from '@utils/ids';
import { getGrayStateByToken, GRAY_AB_TOKEN } from '@utils/grayAB';
import {
    OrderUnifiedInfo,
    OrderBusinessType,
    UnprocessedOrderType,
} from '../../../../Business/pages/OrderManage/shared/types';
import store from '../../../store';

import * as API from './api';

/** 餐饮新形态灰度 */
const UNIFIED_ORDER_GRAY = getGrayStateByToken(GRAY_AB_TOKEN.UNIFIED_ORDER);

/** 更新订单计数 */
const updateOrderCount = (
    payload: Partial<{ [key in UnprocessedOrderType]: string }> & { noticeInner?: boolean },
) => {
    store.dispatch({
        type: 'orderCount/updateCount',
        payload,
    });
};

/**
 * 确认接单
 */
const confirmPhfOrderAndPrint = (
    orderUnifiedInfo: OrderUnifiedInfo,
    operationType: 'auto_push' | 'auto_loop' | 'manual',
) => {
    if (orderUnifiedInfo.businessType !== OrderBusinessType.PHF) {
        return;
    }
    const orderLogData = {
        invokeTime: new Date().getTime(),
        orderId: orderUnifiedInfo.wmOrderViewId,
        poiId: orderUnifiedInfo.wmPoiId,
        type: 0 as const,
    };
    API.phfConfirmOrder(orderUnifiedInfo).then(
        response => {
            const responseTime = new Date().getTime();

            reportCustomMetrics(
                CUSTOM_METRICS.CONFIRM_ORDER.KEY,
                1,
                {
                    [CUSTOM_METRICS.CONFIRM_ORDER.TAGS.HTTP_SUCCESS]: 1,
                    [CUSTOM_METRICS.CONFIRM_ORDER.TAGS.OPERATION_TYPE]: operationType,
                    [CUSTOM_METRICS.CONFIRM_ORDER.TAGS.BUSINESS_CODE]: response.code,
                    [CUSTOM_METRICS.CONFIRM_ORDER.TAGS.BUSINESS_TYPE]:
                        orderUnifiedInfo.businessType === 2 ? 'phf' : 'wm',
                    [CUSTOM_METRICS.CONFIRM_ORDER.TAGS.IS_ORDER2]: 1,
                    [CUSTOM_METRICS.CONFIRM_ORDER.TAGS.RUNTIME]: runtimeType,
                    [CUSTOM_METRICS.CONFIRM_ORDER.TAGS.IS_XP]: isUniversalWindowsXP ? 1 : 0,
                    [CUSTOM_METRICS.CONFIRM_ORDER.TAGS.IS_UNIFIED]: UNIFIED_ORDER_GRAY ? 1 : 0,
                },
                {
                    acctId: Ids.getAcctId(),
                    wmPoiId: Ids.getWmPoiId(),
                },
            );

            if (response.code === 0 || response.code === 10031 || response.code === 10032) {
                // 🖨 打印小票  TODO：打印逻辑里仍存在耦合
                printOrderWhenConfirm(orderUnifiedInfo);

                // 补充协议签约提醒
                if (response.code === 10031) {
                    openSignProtocolModal('美团跑腿');
                } else if (response.code === 10032) {
                    openSignProtocolModal('混合');
                }

                // 设备维度备餐提醒，每个设备只弹三次
                const readTime = parseInt(getStorage('readTime') || '0', 10) || 0;
                if (readTime < 3) {
                    // 展示不足三次，打开弹框并计数
                    setStorage('readTime', `${readTime + 1}`);
                    Modal.confirm({
                        title: '备餐提醒',
                        showCancelButton: false,
                        confirmText: '我知道了',
                        size: 'sm',
                        children:
                            '用户有权在接单1分钟内极速退款，请接单1分钟后开始备餐，以免造成餐损',
                    });
                }
            } else {
                warningToast(response.msg);
            }

            // 履约新形态
            // 全部订单没有计数，只用于列表刷新
            updateOrderCount({
                [UnprocessedOrderType.All]: '1',
                noticeInner: true,
            });

            const domTime = new Date().getTime();

            API.reportOrderLog({ ...orderLogData, responseTime, domTime });
        },
        () => {
            reportCustomMetrics(
                CUSTOM_METRICS.CONFIRM_ORDER.KEY,
                1,
                {
                    [CUSTOM_METRICS.CONFIRM_ORDER.TAGS.HTTP_SUCCESS]: 0,
                    [CUSTOM_METRICS.CONFIRM_ORDER.TAGS.OPERATION_TYPE]: operationType,
                    [CUSTOM_METRICS.CONFIRM_ORDER.TAGS.BUSINESS_TYPE]:
                        orderUnifiedInfo.businessType === 2 ? 'phf' : 'wm',
                    [CUSTOM_METRICS.CONFIRM_ORDER.TAGS.IS_ORDER2]: 1,
                    [CUSTOM_METRICS.CONFIRM_ORDER.TAGS.RUNTIME]: runtimeType,
                    [CUSTOM_METRICS.CONFIRM_ORDER.TAGS.IS_XP]: isUniversalWindowsXP ? 1 : 0,
                    [CUSTOM_METRICS.CONFIRM_ORDER.TAGS.IS_UNIFIED]: UNIFIED_ORDER_GRAY ? 1 : 0,
                },
                {
                    acctId: Ids.getAcctId(),
                    wmPoiId: Ids.getWmPoiId(),
                },
            );
        },
    );
};

export {
    // eslint-disable-next-line import/prefer-default-export
    confirmPhfOrderAndPrint,
};
